import { VehiclePlate as VehiclePlateType } from "@/types/vehicle-plate";
import { ScrollView } from "react-native";
import VehiclePlate from "./VehiclePlate";

export const VehiclePlateScrollView: React.FC<{
  plates: VehiclePlateType[];
  style?: object;
  onChange: React.Dispatch<React.SetStateAction<VehiclePlateType[]>>;
}> = ({ plates, onChange, style }) => {
  return (
    <ScrollView horizontal style={{ marginTop: 8, ...style }}>
      {plates.map((p) => (
        <VehiclePlate
          key={`${p.country}.${p.plate}`}
          plate={p.plate}
          country={p.country}
          onDelete={() =>
            onChange((prevPlates) =>
              prevPlates.filter(
                (plate) =>
                  `${plate.country}.${plate.plate}` !==
                  `${p.country}.${p.plate}`
              )
            )
          }
        />
      ))}
    </ScrollView>
  );
};
